// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"1cd31a9e","829":"5ccfb0bb","878":"bd1daddb"}[chunkId] + ".chunk.js";
};